import { RootState } from '@/store/store';
import { TestFavoritesState } from '@/store/types/testFavoritesTypes';

/**
 * Селекторы избранного тестов. Компоненты читают только их
 * (см. `business-logic.mdc` / `redux-selectors.mdc`).
 */
export const selectTestFavoritesState = (state: RootState): TestFavoritesState => state.testFavorites;

/** В избранном ли тест по id (по умолчанию — нет). */
export const selectIsTestFavorite = (state: RootState, id: number): boolean =>
    selectTestFavoritesState(state).byId[id] ?? false;
